module.exports = __webpack_public_path__ + "img/bird-2-left.562fa9d8.png";